export default {
  allowExperimentalReactions: () => !window.isProduction
};
